'use-strict';

const QuestionProtocol = require('./question-protocol');
const config = require('../data/sleep-config.json');

module.exports = new QuestionProtocol((_evaluation, _gender, _age, answerScore) => {
    if (answerScore >= 25) return 73 + ((answerScore - 25) * 5.4);
    if (answerScore >= 15) return 31 + ((answerScore - 15) * 4.3);
    return answerScore * 2.1;
}, config.questions);